import React, {useEffect, useState} from "react";
import {callWebshopAPI, useShoppingCartApi} from "../api";
import {callAPI} from "../../../lib/common";
import {supportMobileTemplates, suspendResource} from "../../../utils";

const ShoppingCartContext = React.createContext();

const initialCart = suspendResource(callWebshopAPI('webshop/cart'));

const ShoppingCartProvider = (props) => {
  const [loading, setLoading] = useState(() => {
      return initialCart.read();
  });
  const [updating, setUpdating] = useState(false)
  const [error, setError] = useState(false);
  const [data, setData] = useState();
  const [items, setItems] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);

  useEffect(() => {
    if (data) {
      if (!supportMobileTemplates()) {
        if (data.orderLines.filter(ol => ol.type == 0 && ol.product.type != 0).length > 0) {
          document.location.href = '/sections/printsorderv2/cart.php';
          return;
        }
      }
      setItems(data.orderLines.filter(ol => ol.type == 0));
      setTotalPrice(data.summary.totalPrice)
    }
  }, [data])

  useEffect( () => {
      updateCart ();
  }, []);

  const updateCart = async () => {
    setLoading(true);

    let data = null;
    try {
        data = await callWebshopAPI('webshop/cart');
        setData(data);
    }
    catch (err) {
        setError(err)
    }
    setLoading(false)
    return data;
  }

  const updateOrderLine = (orderLine) => {
    return new Promise((resolve, reject) => {
      setItems (items => {
        return items.map ( item => {
          if (item.uuid == orderLine.uuid) {
            return {
              ...item,
              updating: true
            }
          }
          return item;
        })
      })
      setUpdating(true);
      callAPI(`/m/api/webshop/cart/${orderLine.uuid}`, 'PUT', orderLine)
        .then(data => {
          setData(data)
          resolve(data);
        })
        .catch(reject)
        .finally(() => setUpdating(false))
    })
  }

  const updateMultipleOrderLines = (orderLines) => {
    return new Promise((resolve, reject) => {
      setItems (items => {
        return items.map ( item => {
          if (orderLines.find(ol => ol.uuid == item.uuid)) {
            return {
              ...item,
              updating: true
            }
          }
          return item;
        })
      })
      setUpdating(true);
      callAPI(`/m/api/webshop/cart`, 'PUT', orderLines)
          .then(data => {
            setData(data)
            resolve(data);
          })
          .catch(reject)
          .finally(() => setUpdating(false))
    })
  }

  const addItem = (item) => {

  }

  const deleteItem = (item) => {
    return new Promise ((resolve, reject) => {
      callAPI(`/m/api/webshop/cart/${item.uuid}`, 'DELETE')
        .then(data => {
          setData(data)
          resolve(data);
        })
        .catch(reject)
    });
  }

  const updateItem = (item) => {

  }


  return (
    <ShoppingCartContext.Provider value={
      {addItem, items, loading, updating, deleteItem, updateItem, totalPrice, updateCart, updateOrderLine, updateMultipleOrderLines}
    }
    {...props} />
  )
}


const useShoppingCart = () => React.useContext(ShoppingCartContext)
export {ShoppingCartProvider, useShoppingCart}
